import { AxiosInstance } from 'axios'

import { PaymentMethod, RedirectFlow } from '../../../domain'
import { withGenericErrorHandling } from '../errors'

export interface RedirectFlowCreateRequest {
  policyNumber: string
  mandateDescription: string
  successUrl: string
  locale: string
}

export interface GoCardlessClient {
  createRedirectFlow: (params: RedirectFlowCreateRequest) => Promise<RedirectFlow>
  createPaymentMethod: (redirectFlowId: string) => Promise<void>
  getPaymentMethods: (accountCode?: string) => Promise<PaymentMethod[]>
}

export const createGoCardlessClient = (
  getInstance: () => Promise<AxiosInstance>,
): GoCardlessClient => ({
  createRedirectFlow: (params) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.post<RedirectFlow>('/goCardless/flows', params)
      return response.data
    }),

  getPaymentMethods: (accountCode) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.get<PaymentMethod[]>(`/paymentMethods`, {
        data: { accountCode },
      })
      return response.data
    }),

  createPaymentMethod: (redirectFlowId) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      await instance.post(`/goCardless/flows/${encodeURIComponent(redirectFlowId)}`)
    }),
})
